import { Asset } from '../..';
import { coesOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { CoesListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const CoesAsset = () => {
  return (
    <Asset
      productsQuery={coesOffersQueryUpdated}
      ProductItem={CoesListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
